var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEarnNavPortfolioActive = function SvgEarnNavPortfolioActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.286 2.438A10.78 10.78 0 1 0 22.06 13.214H11.286V2.438Z",
    fill: "#305992"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.286 1.114v12.1h12.1A1.115 1.115 0 0 0 24.496 12 13.27 13.27 0 0 0 12.5.004a1.114 1.114 0 0 0-1.215 1.11Z",
    fill: "#4376B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.286 23.995a10.781 10.781 0 0 0 10.776-10.78H11.286v10.78Z",
    fill: "#274673"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.528 12.55a.454.454 0 0 1-.44-.3.45.45 0 0 1 .415-.595.44.44 0 0 1 .355.175.656.656 0 0 0 .5.27h.08a.64.64 0 0 0 .55-1 1.839 1.839 0 0 0-.65-.59.34.34 0 0 1-.175-.29.67.67 0 0 0-.66-.65.67.67 0 0 0-.67.67.32.32 0 0 1-.17.285 1.784 1.784 0 0 0 .84 3.359.445.445 0 1 1-.146.866.46.46 0 0 1-.224-.161.6.6 0 0 0-.5-.26h-.08a.659.659 0 0 0-.53 1.05c.164.207.37.378.605.5a.32.32 0 0 1 .17.284.67.67 0 0 0 .705.7.67.67 0 0 0 .67-.67.32.32 0 0 1 .17-.285 1.784 1.784 0 0 0-.815-3.358Z",
    fill: "#9CB9DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.496 12a13.225 13.225 0 0 0-3.829-8.157l-9.38 9.371h12.1A1.116 1.116 0 0 0 24.495 12Z",
    fill: "#6794C9"
  })));
};
export default SvgEarnNavPortfolioActive;